import * as yup from 'yup';
import { FIELD } from './types';

export const validationSchema = () =>
  yup.object().shape({
    [FIELD.USERNAME]: yup
      .string()
      .nullable()
      .required('Email is mandatory'),
    [FIELD.PASSWORD]: yup
      .string()
      .nullable()
      .required('Password is mandatory'),
  });
